import { ExplainerLayout } from '@/components/ExplainerLayout';
import { KSEF_DLA_JDG } from '@/content/przewodniki';

const KsefDlaJdg = () => <ExplainerLayout guide={KSEF_DLA_JDG} />;

export default KsefDlaJdg;
